export default __webpack_public_path__ + "static/media/alpha-dashboard-admin.8518859e.png";